var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.084 38.11l-6.244-6.228a3.105 3.105 0 00-3.84-.43 17.042 17.042 0 01-8.949 2.535h-.01a16.896 16.896 0 01-6.613-1.339 17.141 17.141 0 01-9.078-9.04A16.939 16.939 0 012.835 7.6a17.012 17.012 0 016.144-5.583 17.085 17.085 0 0116.266.086 17.028 17.028 0 016.176 5.78 16.967 16.967 0 011.047 16.331L29.664 22.9a13.75 13.75 0 001.317-5.757c.04-3.755-1.389-7.285-4.022-9.938-2.633-2.653-6.154-4.114-9.918-4.114A13.975 13.975 0 007.18 7.166a13.869 13.869 0 00-4.08 9.837c.002 3.7 1.458 7.187 4.1 9.817a13.86 13.86 0 009.841 4.077h.009c2.585 0 5.12-.717 7.318-2.073a6.282 6.282 0 013.98-.894 6.21 6.21 0 013.683 1.767l6.244 6.229-2.191 2.183z",
    fill: "#5700FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.66 12.39H8.818v3.052h16.84v-3.051zM18.803 19.969H8.82v3.161h9.984V19.97z",
    fill: "#5700FF"
  })));
}
export default SvgSearch;